import type { Opts } from 'linkifyjs'
import linkifyHtml from 'linkify-html'
import { useWidgetTextWithEmoji } from '@widgets/messenger/compositions/useWidgetTextWithEmoji'
import type { ValueOrRefOrGetter } from '@/types'
import { getValueFromRefOrGetter } from '@/composition/getValueFromRefOrGetter'
import { computed } from '@/composition/vue/compositionApi'

const linkifyOptions: Opts = {
  target: '_blank',
}

export const useWidgetChatMessageText = (text: ValueOrRefOrGetter<string>) => {
  const textValue = computed(() => getValueFromRefOrGetter(text))
  const messageHtml = computed(() => {
    let result = textValue.value.replaceAll('\n', '<br>')
    result = result.replaceAll('  ', ' &nbsp;')
    result = linkifyHtml(result, linkifyOptions)
    return result
  })
  const { textWithEmoji: messageHtmlWithEmoji } = useWidgetTextWithEmoji(messageHtml, '14px')

  return {
    messageHtml: messageHtmlWithEmoji,
  }
}
